import {
	parseAddress,
  parseColeAddress,
	GeoJSON,
	getIconForClient,
	processPoints,
	setMapInstance,
	getMapInstance
} from './google_maps';
export * from './sockets';

export const copy = d => JSON.parse(JSON.stringify(d));

const logger = (ex, context) => {
	if(Raven)
		Raven.captureException(ex, {
			extra : context
		});
}

export {
	parseAddress,
  parseColeAddress,
	GeoJSON,
	getIconForClient,
	processPoints,
	setMapInstance,
	getMapInstance,
	logger
};

export const getImage = (name) => {
  try {
    if(!window.Store || !window.Store.getState().connection)
      throw Error("Application State with connection variable required.");
    const {baseUrl, imagesPath} = window.Store.getState().connection;
    return baseUrl + imagesPath + name;
  }
  catch(ex) {
    console.error(ex);
  }
}

export const getAsset = (pathName) => {
	try {
		if(!window.Store || !window.Store.getState().connection)
			throw Error('No application state.');
		const { baseUrl } = window.Store.getState().connection;
		return `${baseUrl}/assets/${pathName}`
	}
	catch(ex) {
		console.error(ex)
	}
}

export const getIconForPlace = (place) => {
  try {
    if(!window.Store || !window.Store.getState().connection)
      throw Error("Application State with connection variable required.");

    const {baseUrl, imagesPath} = window.Store.getState().connection;

    const icons = {
      accounting : 'icon-banking',
      airport : 'icon-airport',
      amusement_park : undefined,
      aquarium : undefined,
      art_gallery : undefined,
      atm : 'icon-banking',
      bakery : undefined,
      bank : 'icon-banking',
      bar : undefined,
      beauty_salon : undefined,
      bicycle_store : undefined,
      book_store : undefined,
      bowling_alley : undefined,
      bus_station : undefined,
      cafe : undefined,
      campground : undefined,
      car_dealer : 'icon-car_dealer',
      car_rental : 'icon-car_dealer',
      car_repair : 'icon-car_dealer',
      car_wash : 'icon-car_dealer',
      casino : undefined,
      cemetery : undefined,
      church : undefined,
      city_hall : undefined,
      clothing_store : 'icon-store',
      convenience_store : 'icon-store',
      courthouse : 'icon-government',
      dentist : 'icon-medical',
      department_store : 'icon-store',
      doctor : 'icon-health',
      electrician : undefined,
      electronics_store : undefined,
      embassy : undefined,
      establishment : undefined,
      finance : undefined,
      fire_station : undefined,
      florist : undefined,
      food : 'icon-food',
      funeral_home : undefined,
      furniture_store : undefined,
      gas_station : 'icon-gas',
      general_contractor : undefined,
      grocery_or_supermarket : undefined,
      gym : undefined,
      hair_care : undefined,
      hardware_store : undefined,
      health : 'icon-medical',
      hindu_temple : undefined,
      home_goods_store : 'icon-store',
      hospital : 'icon-medical',
      insurance_agency : undefined,
      jewelry_store : undefined,
      laundry : undefined,
      lawyer : undefined,
      library : undefined,
      liquor_store : undefined,
      local_government_office : undefined,
      locksmith : undefined,
      lodging : undefined,
      meal_delivery : 'icon-food',
      meal_takeaway : 'icon-food',
      mosque : undefined,
      movie_rental : undefined,
      movie_theater : undefined,
      moving_company : undefined,
      museum : undefined,
      night_club : undefined,
      painter : undefined,
      park : undefined,
      parking : undefined,
      pet_store : undefined,
      pharmacy : undefined,
      physiotherapist : undefined,
      place_of_worship : undefined,
      plumber : undefined,
      police : undefined,
      post_office : undefined,
      real_estate_agency : undefined,
      restaurant : undefined,
      roofing_contractor : undefined,
      rv_park : undefined,
      school : undefined,
      shoe_store : 'icon-store',
      shopping_mall : undefined,
      spa : undefined,
      stadium : undefined,
      storage : undefined,
      store : 'icon-store',
      subway_station : undefined,
      synagogue : undefined,
      taxi_stand : undefined,
      train_station : undefined,
      transit_station : undefined,
      travel_agency : undefined,
      university : undefined,
      veterinary_care : undefined,
      zoo : undefined,
    }
    const types = place.types.filter(type => (icons[type]));
    if(types.length > 0) {
      return `${baseUrl + imagesPath + icons[types[0]]}.png`;
    }
    else {
      return `${baseUrl + imagesPath}icon-info.png`;
    }
  }
  catch(ex) {
    console.error(ex)
  }
}

export const makeCancelable = (promise) => {
  let hasCanceled_ = false;

  const wrappedPromise = new Promise((resolve, reject) => {
    promise.then((val) =>
      hasCanceled_ ? reject({isCanceled: true}) : resolve(val)
    );
    promise.catch((error) =>
      hasCanceled_ ? reject({isCanceled: true}) : reject(error)
    );
  });

  return {
    promise: wrappedPromise,
    cancel() {
      hasCanceled_ = true;
    },
  };
};

export const convertContactToClient = contact => ({
	...contact
});

export const parsePhone = phone => {
  phone = phone.toString().replace(/[^\d]/g, "");

  if(phone.length == 10) {
    return phone.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
  }
  if(phone.length > 10) {
    return phone.replace(/^(\d*)(\d{3})(\d{3})(\d{4})/, '+$1 ($2) $3-$4')
  }

  return null;
}

Number.prototype.toRadians = function() {
	return this * Math.PI / 180
}

export const distance = (p1,p2) => {
	//Borrowed from http://www.movable-type.co.uk/scripts/latlong.html
	const { lat: lat1, lng: lon1 } = p1;
	const { lat: lat2, lng: lon2 } = p2;

	let R = 6371e3; // metres
	let φ1 = lat1.toRadians();
	let φ2 = lat2.toRadians();
	let Δφ = (lat2-lat1).toRadians();
	let Δλ = (lon2-lon1).toRadians();

	let a = Math.sin(Δφ/2) * Math.sin(Δφ/2) +
					Math.cos(φ1) * Math.cos(φ2) *
					Math.sin(Δλ/2) * Math.sin(Δλ/2);
	let c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
	let d = R * c;

	return d;
}



// WEBPACK FOOTER //
// ./src/common/utils/index.js